/** A piece of text and whether it matches a searched word. */
export interface TextPart {
  text: string;
  match: boolean;
}

const fold = (value: string) => value.toLocaleLowerCase().replaceAll('ё', 'е');

/**
 * Splits `text` into the parts that contain one of the words of `query` (case-insensitive, ё = е) and the rest, for
 * highlighting search results. Words shorter than two characters are ignored.
 */
export function highlightParts(text: string, query: string): TextPart[] {
  const words = [
    ...new Set(
      query
        .split(/\s+/u)
        .map(fold)
        .filter((w) => w.length >= 2),
    ),
  ];
  if (!text || words.length === 0) return text ? [{ text, match: false }] : [];
  // Folding keeps the length of the text (ё → е, case changes of Cyrillic/Latin letters), so indexes line up.
  const folded = fold(text);
  const marks = new Array<boolean>(text.length).fill(false);
  for (const word of words) {
    let from = folded.indexOf(word);
    while (from >= 0) {
      marks.fill(true, from, from + word.length);
      from = folded.indexOf(word, from + word.length);
    }
  }
  const parts: TextPart[] = [];
  for (let i = 0; i < text.length; i++) {
    const match = marks[i] ?? false;
    const last = parts.at(-1);
    if (last?.match === match) last.text += text.charAt(i);
    else parts.push({ text: text.charAt(i), match });
  }
  return parts;
}
